module.exports = __webpack_public_path__ + "static/media/tax.c064ace6.png";